import type { AllRouteEndpoints } from "@dashboardApi/apis/routeTypes";

export const engagementCanvasCopyCacheKeys: AllRouteEndpoints[] = [];
